import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column-reverse'
        }
    },
    payoutWarning: {
        backgroundColor: theme.palette.error.dark,
        padding: theme.spacing(3),
        borderRadius: '4px'
    }
}));

export default useStyles;
